type PicturePropsV2 = {
  path: string;
  alt?: string | null;
  width?: number | null;
  height?: number | null;
  className?: string;
  style?: React.CSSProperties;
  onClick?: (event: React.MouseEvent<HTMLImageElement>) => void;
};

export const PictureComponentV2 = ({
  path,
  alt = '',
  className = '',
  width,
  height,
  style,
  onClick,
}: PicturePropsV2) => (
  <img
    onClick={onClick}
    style={style}
    width={width ?? undefined}
    height={height ?? undefined}
    className={`twic pic ${className}`}
    data-src={`image:pictures/${path}`}
    src="https://staycation.twic.pics/v1/placeholder:transparent"
    alt={alt ?? ''}
  />
);
